(function () {
  'use strict';

  /**
   * @ngdoc object
   * @name hardSoftRule.controller:HardSoftRuleCtrl
   *
   * @description
   *
   */
  angular
    .module('hardSoftRule')
    .directive('focusOn',function($timeout) {
    		return {
    			restrict : 'A',
    			link : function(vm,$element,$attr) {
    				vm.$watch($attr.focusOn,function(_focusVal) {
    					$timeout(function() {
    						_focusVal ? $element[0].focus() :
    							$element[0].blur();
                    	});
                	});
            	}
    		}
    	})
    .controller('HardSoftRuleCtrl', HardSoftRuleCtrl);

  function HardSoftRuleCtrl(HardSoftRuleRequestFactory,CommonFuelService,CommonMasterData,applicationConstants,HardSoftRuleService,MessageService) {
    var vm = this;
    vm.ctrlName = 'HardSoftRuleCtrl';

    vm.model = {
            searchPanelToggle:true,
            searchCriteria:{
            	crewType :null,
            	description :null,
            	status:null
            },
            masterList: {
                crewTypeList:[],
                statusList:[],
                discriptionList:[],
                acmiTypesList:[],
                ruleClassificationList:[]
            },
            ruleList:[],
            initialSearchDone:false,
            selectedIsHard:"Y",
            selectedRule: null,
            editorMode: applicationConstants.EDITOR_STATUS.ADD,
            submitError: false
        };

    vm.clickOnSearch = function (){
    	CommonMasterData.getRuleDescList(vm.model.selectedIsHard,function(discriptionList){
        	vm.model.masterList.discriptionList = discriptionList;

        },function () {});
    	 vm.model.searchPanelToggle = ! vm.model.searchPanelToggle;
         vm.model.initialSearchDone=false;
    }

    vm.submitSearch = function (params){
    	search(params);
    	   vm.model.selectedRule.durationForRoster = 0;
         vm.model.selectedRule.companyValue1 = " ";
         vm.model.selectedRule.durationForRoster =" ";
         vm.model.selectedRule.desirability = " ";
         vm.model.selectedRule.description = " ";
         vm.model.selectedRule.acmiCodes = [];
    };

    function search(params){
    	vm.model.initialSearchDone=true;
    	vm.model.ruleList = [];
    	vm.model.searchCriteria = params;
    	HardSoftRuleService.setSearchCriteria(vm.model.searchCriteria,vm.model.selectedIsHard);
    	HardSoftRuleService.getRegulations(
    	            function (regList) {
    	                vm.model.ruleList = regList;
    	                vm.model.searchPanelToggle = false;
    	                if(vm.model.ruleList.length===0){
    	                    MessageService.error('No records found');
    	                }
    	            },
    	            function (error) {
    	                MessageService.error(error);
    	            }
    	        );
    }

    vm.tabClick = function(tabID){
        if(vm.model.searchCriteria.crewType!==null){
            if(tabID===2){
                vm.model.selectedIsHard = "N";
            }else{
                vm.model.selectedIsHard = "Y";
            }
            CommonMasterData.getRuleDescList(vm.model.selectedIsHard,function(discriptionList){
                vm.model.masterList.discriptionList = discriptionList;
            },function () {});
            search(vm.model.searchCriteria);
        }
    };

    vm.selectReg= function(regulation){
    	vm.model.editorMode =  applicationConstants.EDITOR_STATUS.EDIT;
        vm.model.selectedRule = HardSoftRuleService.getRuleForEdit(regulation);
        angular.forEach(vm.model.masterList.ruleClassificationList,function (classification) {
                if (classification.ruleClassificationCode === regulation.ruleClassificationCode) {
                    vm.model.selectedRule.ruleClassification = classification;
                }
        });
    };


    vm.submitReg = function (action, reg) {
       vm.model.selectedRule = reg;
       console.log(reg.acmiCodes);
       if (reg.onlyACMI && (reg.acmiCodes.length === 0 || reg.acmiCodes === null)) {
           vm.model.selectedRule.submitError = true;
          return;
       }
       HardSoftRuleService.saveSelectedReg(vm.model.selectedRule,
             function (response) {
                 if(response.success){
                      MessageService.success('Successfully saved the record!');
                      vm.submitSearch(vm.model.searchCriteria);
                      vm.model.selectedRule = HardSoftRuleService.getEmptyRule();
                      vm.model.selectedRule.companyValue1 = " ";
                      vm.model.selectedRule.durationForRoster = 0;
                      vm.model.selectedRule.desirability = " ";
                      vm.model.selectedRule.description = " ";

                  }else{
                        MessageService.error(response.errors[0]);
                   }
                },
                function (error) {
                    MessageService.error(error);
                }
            );
    };

    vm.change = function (flag, operation, selectedItems) {
    	if(flag==='modelNumber'){
    		AircraftRegistrationService.getCapacity(selectedItems.modelNumber,
    		function (response) {
    			if(vm.model.selectedAirCraft=== null){
    				vm.model.selectedAirCraft = AircraftRegistrationService.getNewReg();
    			}
    			vm.model.selectedAirCraft.capacity = response.capacity;
    		},function (error) {
                MessageService.error(error);
            }

    		);
    	}
    }

    function searchACMITypes() {

      CommonMasterData.getACMITypesList(function (acmiTypes) {
                        vm.model.masterList.acmiTypesList = acmiTypes;
                    }, function (error) {

                    });


    }



    CommonMasterData.getCrewTypeList(function(crewTypeList){
    	vm.model.masterList.crewTypeList = crewTypeList;
        vm.model.masterList.statusList = CommonFuelService.getStatusList();
        vm.model.searchCriteria.status = CommonFuelService.getDefaultStatus();

    },function () {});

    CommonMasterData.getRuleDescList(vm.model.selectedIsHard,function(discriptionList){
    	vm.model.masterList.discriptionList = discriptionList;

    },function () {});

    searchACMITypes();

     CommonMasterData.getRuleClassificationTypes(function (ruleClassificationTypes) {
        vm.model.masterList.ruleClassificationList = ruleClassificationTypes;
      }, function () {
        console.log('Rule Classification types retrieval error');
      });

  }
}());
